import { Button } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import { gidFor } from "PFCore/helpers/gid";
import { isMsTeams, openChatInMsTeams } from "PFCore/helpers/ms_teams";
import { saveConversation } from "PFCore/services/chat/save_conversation";
import { saveParticipant } from "PFCore/services/chat/save_participant";
import { fetchProfile } from "PFCore/services/profile";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const OpenNewChatButton = ({ item, activity, participants, renderChat, currentProfile }) => {
  const { t } = useTranslation();

  const [isPending, setIsPending] = useState(false);

  if (!participants) {
    return <LoadingDots />;
  }

  const participant = participants.find(({ profile: { id } }) => id === item.id);

  const [kind, copy, qaIdSuffix] = participant
    ? ["secondary", t("conversations.open121"), ".open"]
    : isPending
      ? ["blank", <LoadingDots key="idem" />, ".pending"]
      : ["primary", t("conversations.start121"), ".start"];

  return (
    <Button
      qaId={`OpenNewChatButton${qaIdSuffix}`}
      small
      style={{ minWidth: 80 }}
      kind={kind}
      disabled={isPending}
      onClick={() => {
        if (isMsTeams()) {
          fetchProfile(item.id).then((profile) => openChatInMsTeams(profile?.email || ""));
          return;
        }
        if (participant) {
          renderChat(participant.conversationId);
        } else {
          setIsPending(true);
          saveConversation({
            target: gidFor("Task", activity.id),
            ownerId: currentProfile.id
          }).then((resp) => {
            renderChat(resp.id);
            saveParticipant({
              conversationId: resp.id,
              profileId: item.id
            });
          });
        }
      }}
    >
      {copy}
    </Button>
  );
};

OpenNewChatButton.propTypes = {
  item: PropTypes.shape({ id: PropTypes.number }).isRequired,
  activity: PropTypes.shape({ id: PropTypes.number }).isRequired,
  renderChat: PropTypes.func.isRequired,

  participants: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number })),
  currentProfile: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
};

export default OpenNewChatButton;
